<template>
    <modal ref="modal" :fade="false" :v-center="true" modal-additional-classes="modal-pageerror modal-noclose" :options="modalOptions" :modal-container="'specialModal'" :hide-x-button="true">
        <template v-slot:title>
            <div>Signed Out</div>
        </template>

        <slot>
            <div>
                <p>
                  You've been signed out due to inactivity. Please sign in again.
                </p>
            </div>
        </slot>

        <template v-slot:footer>
            <button-row center>
                <a href @click.prevent="onClick" class="btn btn-primary">Go to Sign In</a>
            </button-row>
        </template>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/ModalMixin'
import * as nativeBridge from '@/native-bridge'

export default {
    mixins: [ModalMixin, ],
    data() {
        return {
            modalOptions: {
                backdrop: 'static',
                keyboard: false,
            },
        }
    },
    methods: {
        onClick() {
            this.$store.dispatch('LOGOUT', true)
            // Inside a native app, sign-in belongs to the app. The web login would
            // clear isInApp (Login.vue) and sign the user in to a browser-mode ESS
            // inside the app, whose Log Out never tells the app to clear its
            // cookies. app-logout hands back to the app in both shells.
            if (nativeBridge.isNativeHost()) {
                this.$router.push({name: 'app-logout'})
            } else if (this.$route.name != 'login') {
                this.$router.push({name: 'login'})
            }
        },
        close(forceClose = false) {
            if (forceClose) {
                ModalMixin.methods.close.call(this)
            }
        },
    },
}
</script>
